import React from 'react';
import { rootActions, useAppDispatch, useAppSelector } from '../../data/store';
import ProductPriceFormat from '../../../../products/product-price/product-price-format';
import { CartSteps } from '../../enums/cart-steps';
import StepOverviewItem from './step-overview-item';
import { sendGAEvent } from '../../../../../domain/marketing/gtm-provider';
import SubscriptionOverviewItem from '../subscription/subscription-overview-item';
import FreeWithYourPurchaseOverview from '../free-with-your-purchase/free-with-your-purchase-overview';
import Coupon from '../coupon/coupon';
import InstantSavings from '../instant-savings/instant-savings';
import { isConfirmationMsgVisible } from '../../domain/free-plugin-provider';
import FreePluginBox from '../free-plugin/free-plugin-box';

const Step2Overview = () => {

    const dispatch = useAppDispatch();
    const cartData = useAppSelector(store => store.root.cartData);
    const priceData = cartData.priceData;

    /**
     * return to the first step
     */
    const editCartHandler = () => {
        dispatch(
            rootActions.main({
                cartStep: CartSteps.First,
            })
        );

        sendGAEvent('Edit Cart', 'Step 2');
    };

    return (
        <div className="bg-white border rounded w-full md:w-5/12 lg:w-1/4 md:top-60px sticky self-start">
            <div className="mx-6 py-3">

                <div className="flex items-center justify-between font-bold mb-4">
                    <p className="text-2xl text-gray-700 mr-2">Order Summary</p>

                    <button
                        type="button"
                        onClick={ editCartHandler }
                        className="text-blue-200 font-bold text-right">
                        Edit Cart
                    </button>
                </div>

                {
                    cartData && cartData.cartItems && cartData.cartItems
                        .filter(cartItem => cartItem.isActive)
                        .map((cartItem, i) => {

                        return (
                            <StepOverviewItem
                                key={ cartItem.cartItemGUID }
                                cartItem={ cartItem }
                            />
                        )
                    })
                }

                <SubscriptionOverviewItem />
                { cartData.subscription && <div className="border-b mb-4"></div> }

                <FreeWithYourPurchaseOverview />

                {
                    priceData.subTotalPrice !== priceData.totalPrice &&
                    <div className="text-gray-500 font-bold flex items-center justify-between mb-2">
                        <span className="mr-2">Subtotal</span>
                        <span className="ml-2"><ProductPriceFormat price={ priceData.subTotalPrice } /></span>
                    </div>
                }

                {
                    priceData.shipping > 0 &&
                    <div className="text-gray-500 font-bold flex items-center justify-between mb-2">
                        <span className="mr-2">Shipping</span>
                        <span className="ml-2"><ProductPriceFormat price={ priceData.shipping } /></span>
                    </div>
                }

                {
                    priceData.taxWithoutShippingTax > 0 &&
                    <div className="text-gray-500 font-bold flex items-center justify-between mb-2">
                        <span className="mr-2">Tax</span>
                        <span className="ml-2"><ProductPriceFormat price={ priceData.taxWithoutShippingTax } /></span>
                    </div>
                }

                {
                    priceData.shippingTax > 0 &&
                    <div className="text-gray-500 font-bold flex items-center justify-between mb-2">
                        <span className="mr-2">Shipping Tax</span>
                        <span className="ml-2"><ProductPriceFormat price={ priceData.shippingTax } /></span>
                    </div>
                }

                {
                    priceData.totalDiscountPrice > 0 &&
                    <div className="text-green font-bold flex items-center justify-between mb-4">
                        <span className="mr-2">Discounts</span>
                        <span className="ml-2">-<ProductPriceFormat price={ priceData.totalDiscountPrice } /></span>
                    </div>
                }

                <div className="text-3xl text-gray-700 flex items-center justify-between mb-4">
                    <span className="mr-2">Order Total</span>
                    <span className="ml-2"><ProductPriceFormat price={ priceData.totalPrice } /></span>
                </div>

                <SubscriptionOverviewItem />

                <Coupon />
                <InstantSavings />
                { isConfirmationMsgVisible(cartData) && <FreePluginBox /> }

            </div>
        </div>
    )
};

export default Step2Overview;